/**
 * @fileoverview Supabase client configuration
 * @description Creates and exports Supabase client for the admin dashboard
 * @module lib/supabase
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl =
  (import.meta.env.VITE_SUPABASE_URL as string) ||
  (import.meta.env.EXPO_PUBLIC_SUPABASE_URL as string);
const supabaseAnonKey =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string) ||
  (import.meta.env.EXPO_PUBLIC_SUPABASE_KEY as string);

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
